import { ClockIcon, ClockOffIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';
import { FadeIn, ScaleIn } from '../Transitions';

export const GetReady = ({
  timeBasedScoring,
}: {
  timeBasedScoring: boolean;
}) => {
  const translate = useTranslations('presenting.legacy');

  const Icon = timeBasedScoring ? ClockIcon : ClockOffIcon;

  return (
    <>
      <ScaleIn>
        <Icon color="primary" size={120} />
      </ScaleIn>
      <FadeIn>
        <Box alignItems="center">
          <Text color="text" fontWeight="semiBold" fontSize="250">
            {timeBasedScoring
              ? translate('animating_lobby.answer_fast')
              : translate('animating_lobby.max_points_correct_answer')}
          </Text>
        </Box>
      </FadeIn>
    </>
  );
};
